export default "__VITE_ASSET__9fdef43f__"